import React, {Fragment} from 'react'
import { UnoUtil } from 'uno-security-common'
import { withTranslation } from 'react-i18next';

const EaseContactInfo = UnoUtil.EaseContactInfo;

class ForgetPasswordSendEmailConfirmComponent extends React.Component {
    constructor(props){
        super(props);
        this.cmeUno = props.cmeUno;
    }

    render(){
        const messages = this.cmeUno.messages;
        const {t} = this.props;
        return (
            <Fragment>
                <h1 className="flush--bottom">
                    {t('forgetPasswordSendEmail.title')}
                </h1>
                <div>
                    <p><strong> {t('forgetPasswordSendEmail.email_sent')}</strong></p>
                    <p>{t('forgetPasswordSendEmail.email_not_find')}</p>
                    <div>
                        {t('common.us_contact')}<br/>
                        {t('common.eu_contact')}<br/>
                        {t('common.as_contact')}<br/><br/>
                    </div>

                    {/*<EaseContactInfo messages={messages}/>*/}
                </div>
            </Fragment>

        );
    }
}

export default withTranslation()(ForgetPasswordSendEmailConfirmComponent);
